import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from '../API/auth.service';
import { inject } from '@angular/core';

export const trainerGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.getUser();

  if (!user) {
    router.navigate(['/login']);
    return false;
  }

  if (user.userRoles.filter(role => role.role === 'TRAINER').length > 0) {
    return true;
  }

  router.navigate(['/']);
  return false;
};
